import { useSelector } from 'react-redux';
import { RootState } from '../store/store';

const useAuth = () => {
  const token = useSelector((state: RootState) => state.auth.accessToken);
  const isRefreshing = useSelector((state: RootState) => state.auth.isRefreshing);
  const mustChangePassword = useSelector((state: RootState) => state.auth.mustChangePassword);

  return { token, isRefreshing, mustChangePassword };
};

export default useAuth;
